import { createContext, useContext } from "react";

export const ApiKeyContext = createContext<string | null>(null);

export function useApiKey() {
  const key = useContext(ApiKeyContext);
  if (key === null) {
    throw new Error("ApiKeyContext non initialisé");
  }
  return key;
}
